import { useEffect } from "react";

export interface PickerOption {
  value: string;
  label: string;
  description?: string;
  /** 視覚的に区切る(下にセパレータを引く)。クリア系の選択肢用 */
  separator?: boolean;
}

interface Props {
  title: string;
  options: PickerOption[];
  currentValue: string | null;
  emptyMessage?: string;
  onSelect: (value: string) => void;
  onCancel: () => void;
}

export function PickerModal({
  title,
  options,
  currentValue,
  emptyMessage,
  onSelect,
  onCancel,
}: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div className="modal-backdrop" onMouseDown={onCancel}>
      <div className="modal modal-picker" onMouseDown={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        {options.length === 0 ? (
          <div className="picker-empty">
            {emptyMessage ?? "選択肢がありません。manifest に登録してください。"}
          </div>
        ) : (
          <div className="picker-list">
            {options.map((opt, i) => {
              const prevHadSeparator = i > 0 && options[i - 1]!.separator;
              return (
                <button
                  key={opt.value + "_" + i}
                  className={
                    "picker-option" +
                    (currentValue === opt.value ? " active" : "") +
                    (prevHadSeparator ? " after-sep" : "")
                  }
                  onClick={() => onSelect(opt.value)}
                >
                  <div className="picker-label">{opt.label}</div>
                  {opt.description && (
                    <div className="picker-desc">{opt.description}</div>
                  )}
                </button>
              );
            })}
          </div>
        )}
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
}
